module.exports = __webpack_public_path__ + "static/media/alpi-logo.dd40160d.svg";